const createToggleEvents = element => {
  const toggleButton = element.querySelector('[data-toggle="button"]')
  const toggleContent = element.querySelector('[data-toggle="content"]')
  const accordionHeader = element.querySelector(
    '[data-toggle="accordion-header"]'
  )

  if (element.contains(toggleButton)) {
    toggleButton.addEventListener('click', event => {
      if (
        // let this event click through
        Object.values(event.target.classList).includes(
          'js-cc-toggle--click-through'
        )
      ) {
        return true
      }

      event.preventDefault()

      if (element.hasAttribute('data-accordion')) {
        accordionHeader.classList.toggle('--is-active')
      }

      toggleContent.classList.toggle('+display-none')
    })
  }
}

const bindToggleEvents = selector => {
  const elements = document.body.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createToggleEvents(element)
    })
  }
}

bindToggleEvents('[data-toggle="container"]')
